module.exports = __webpack_public_path__ + "1ff4ee0d8032f77c34a6d7ffd0ca866f.pdf";